import { AuthState } from '@okta/okta-auth-js';

import { CommodityGroupsMassUpdates } from '../../services/backend/CommodityGroupsMassUpdates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCommodityGroupsMassUpdates: () => CommodityGroupsMassUpdates<AuthState> = () => {
  return useBaseApiClient(CommodityGroupsMassUpdates);
};
